/**
 * Add to Yaruta (YAR-556): a file a parent added is an `emails` row with
 * `source = 'upload'`; whether it was a photo or a file lives in
 * `preprocessing_metadata.upload.kind`, written by `uploads-create`
 * (Decision D9).
 */

export type UploadKind = 'photo' | 'file';

/** `'photo'` / `'file'` from the narrow feed alias or the metadata; else null. */
export function toUploadKind(value: unknown): UploadKind | null {
  return value === 'photo' || value === 'file' ? value : null;
}

export function isUpload(email: { source?: string | null }): boolean {
  return email.source === 'upload';
}

/** Null for an email (source `'email'` or missing) or missing metadata. */
export function uploadKindOf(email: {
  source?: string | null;
  preprocessing_metadata?: unknown;
}): UploadKind | null {
  if (!isUpload(email)) return null;
  const metadata = email.preprocessing_metadata;
  if (!metadata || typeof metadata !== 'object') return null;
  const upload: unknown = (metadata as { upload?: unknown }).upload;
  if (!upload || typeof upload !== 'object') return null;
  return toUploadKind((upload as { kind?: unknown }).kind);
}

/**
 * The kind to draw for a row: its recorded kind, a photo when an upload's
 * kind is missing (never an email's Gmail chrome), null for an email.
 */
export function uploadDisplayKind(email: {
  source?: string | null;
  preprocessing_metadata?: unknown;
}): UploadKind | null {
  if (!isUpload(email)) return null;
  return uploadKindOf(email) ?? 'photo';
}
